export default {

  setDialog (state, value) {
    state.dialog = value
  },
  setProduct (state, value) {
    state.product = value
  },
  setBackToEditing (state, value) {
    state.backToEditing = value
  },
  setCurrentView (state, value) {
    state.currentView = value
  },
  setResubmittedEndingAt (state, resubmittedEndingAt) {
    state.resubmittedEndingAt = resubmittedEndingAt
  }
}
